/**
 * True when running inside the Capacitor native shell (iOS/Android app). The
 * webview is served from capacitor://localhost with no reverse proxy, and it
 * cannot use cookies, so the SPA must talk to the backend at an absolute URL
 * and authenticate with a Bearer token.
 *
 * Detected via the global object Capacitor injects at runtime — no import — so
 * this module carries no native dependency on the web and returns false cleanly
 * in tests.
 */
export function isNativeShell(): boolean {
  const cap = (globalThis as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return typeof cap?.isNativePlatform === 'function' && cap.isNativePlatform();
}

/**
 * Native platform id ('ios' | 'android' | 'web'), read from the same injected
 * global. 'web' when not running in the native shell.
 */
export function getNativePlatform(): string {
  const cap = (globalThis as { Capacitor?: { getPlatform?: () => string } }).Capacitor;
  return typeof cap?.getPlatform === 'function' ? cap.getPlatform() : 'web';
}
